export default __webpack_public_path__ + "static/media/456.3610a3f9.png";